<template>
    <header class="mb-10 flex flex-col items-center">
        <div class="w-12 bg-black h-0.5 mb-2"></div>
        <h2 class="uppercase primary-font">
            <slot></slot>
        </h2>
    </header>
</template>
